export const getDevicePixelRatio = () => {
  return window?.devicePixelRatio || 1;
};
